<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="(overlay.name)"
        ref="unitsGroupsLayer"
        @ready="onReady()"
    >
        <l-marker-cluster-group
            ref="unitsGroupsCluster"
            id="units-groups-cluster"
            :spiderfyOnEveryZoom="false"
            :spiderfyOnMaxZoom="false"
            :showCoverageOnHover="false"
            :zoomToBoundsOnClick="true"
            :chunkedLoading="true"
            :disableClusteringAtZoom="disableClusteringAtZoom"
            :removeOutsideVisibleBounds="false"
            :iconCreateFunction="_defaultClusterIconCreate"
            @clusterclick="onClusterClick"
        ></l-marker-cluster-group>
    </l-layer-group>

    <div class="units-groups-on-map" v-if="unitsWithoutCluster?.length || unitsFilter?.name"
         @mouseenter="disabledMapEvents"
         @mouseleave="enableMapEvents"
    >
        <div class="flex align-items-canter flex-gap-5 boby2 mb__12">
            <div class="filter-search">
                <input class="filter-search__input" type="text" :placeholder="$t('text.Search')" v-model.trim="unitsFilter.name">
            </div>
        </div>
        <ul class="units-groups-on-map__list">
            <li v-for="unit in unitsWithoutCluster"
                :key="unit.id"
                class="units-groups-on-map__item flex align-items-canter flex-gap-5 boby2"
                @click.stop="unitClick(unit)"
            >
                <SvgIcon name="car" :class="unit.statusClass"/>
                <span>{{ unit.name }}</span>
                <div class="units-groups-on-map__color" :style="{background: unit.color}"></div>
            </li>
        </ul>
    </div>
</template>
<script>
import {LLayerGroup} from "@vue-leaflet/vue-leaflet";
// import DriftMarker from "leaflet-drift-marker";
// import * as L from "leaflet";
import {LMarkerClusterGroup} from "vue-leaflet-markercluster";
import {mapGetters, mapActions} from "vuex";
import {useToast} from "vue-toastification";
import debounce from "lodash/debounce";
import {arrayFilter_OnlyUnique, diffObjects, updateObjectByDiff} from "@/lib/lib";

const isUnitsGroupsCluster = (localStorage.getItem(process.env.VUE_APP_PRODUCT+'.isUnitsGroupsCluster') === 'true')
//console.log('isUnitsGroupsCluster', isUnitsGroupsCluster)

export default {
    name: "SectionMap_layer_units_groups",
    emits: ['update:modelValue'],
    mixins: [],
    inject: ['L', 'unitIcon', 'mapLeafletObject', 'unitIconByType', 'mapBounds', 'disabledMapEvents', 'enableMapEvents'],
    props: {
        modelValue: Object,
    },
    components: {
        LMarkerClusterGroup,
        LLayerGroup,
    },
    data() {
        return {
            locatorTokenLoading: false,
            locatorUrl: '',
            modalWindows: {},
            toast: useToast(),
            openGeozoneEditControlPosition: 'topright',
            unitsGroupsLayer: null,
            unitsGroupsCluster: null,
            disableClusteringAtZoom: isUnitsGroupsCluster ? 17 : 1,
            unitsIdsWithoutCluster: [],
            unitsFilter: {name: ''}
        }
    },
    computed: {
        ...mapGetters([
            "getAppUserId",
            "getUnitsOnMap",
            "getUnitsByIds",
            "getUnitsLmsgsLatlngByIds",
            "getUnitsMarkersOptionsByIds",
            "getUnitsGroupsByIds",
            "getUnitsGroupsOnMap",

            "getMapPaddingBounds",
            "isLimitedUser",
            "isUnitsLiteLoad",
            "isUnitsLmsgsLiteLoad",
            "isUnitsGroupsLiteLoad",
        ]),
        overlay() {
            return this.modelValue
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        isShowLayer() {
            return this.overlay?.showLayer
        },
        groupId() {
            return this.routeFilter.groupId
        },
        groupsFiltered() {
            return (this.groupId) ? [this.getUnitsGroupsByIds[this.groupId]] :
                this.getUnitsGroupsOnMap.map(gid => this.getUnitsGroupsByIds[gid]).filter(g => !!g)
        },
        unitsFilterByGroups() {
            return this.groupsFiltered
                .map(g => g?.units || [])
                .flat()
                .filter(arrayFilter_OnlyUnique)
                .filter(uId => !!this.getUnitsByIds[uId] && !this.getUnitsByIds[uId].parent__id)
        },
        unitsOnMap() {
            if (!this.isShowLayer || !this.isUnitsLiteLoad || !this.isUnitsLmsgsLiteLoad || !this.isUnitsGroupsLiteLoad) return []
            let unitsOnMap = this.unitsFilterByGroups
            return unitsOnMap
        },
        unitsMarkersOptions(){
            return this.unitsOnMap.reduce((markersByIds, id) => {
                    markersByIds[id] = this.getUnitsMarkersOptionsByIds[id]
                    return markersByIds
                }, {})
        },
        watchUpdateVisibleUnitsList() {
            if (!this.mapBounds) return null
            let markers = this.unitsOnMap
                .map(id => this.getUnitsMarkersOptionsByIds[id]?.latlng)
                .filter(latlng => latlng && this.mapBounds.contains(latlng))

            return JSON.stringify(markers);
        },
        unitsWithoutCluster(){
            let name = this.unitsFilter?.name?.toLowerCase()
            return this.unitsIdsWithoutCluster
                .filter(meta => !name || meta?.name_?.includes(name))
                .map(meta => {
                    let group = this.groupsFiltered?.find(g => g?.units?.find(id => id == meta.id));
                    return {
                        ...meta,
                        color: group?.color,
                    }
                })
        },
    },
    watch: {
        getMapPaddingBounds: {
            handler: function (newVl) {
                let latlng = this.getUnitsLmsgsLatlngByIds[this.routeFilter.unitId]
                if(this.$isDevelopment) console.log('fitBounds getMapPaddingBounds', newVl, {...this.$consts.components.map.paddingBounds}, latlng)
                if (!latlng) return false;

                //newVl = newVl || this.$consts.components.map.paddingBounds
                if(newVl) {
                    if(this.$isDevelopment) console.log('fitBounds switchUnitTracking', 'MapPaddingBounds', this.getMapPaddingBounds)
                    this.mapLeafletObject.fitBounds([latlng], newVl)
                } else {
                    console.error('setView switchUnitTracking', {...latlng})
                    this.mapLeafletObject.setView(latlng, 15)
                }
            },
            deep: true
        },
        unitsOnMap: {
            handler: function (newUnits/*, oldUnits*/) {
                // if(this.$isDevelopment) console.log('SectionMap watch unitsOnMap', newUnits, oldUnits)
                this.debouncedSetMarkers(newUnits)
                this.debouncedUpdateVisibleUnitsList()
            },
            deep: true,
            // immediate: true,
        },
        mapBounds: {
            handler: function (nVal) {
                if (nVal) {
                    this.debouncedUpdateVisibleUnitsList()
                }
            },
            deep: true
        },
        watchUpdateVisibleUnitsList: {
            handler: function (nVal, oldVal) {
                if(nVal != oldVal) {
                    this.debouncedUpdateVisibleUnitsList()
                }

            },
            deep: true
        },
        unitsMarkersOptions: {
            handler: function (newUnitsMarkers, oldUnitsMarkers) {
                let diff = Object.keys(newUnitsMarkers)
                    .map(id => diffObjects(oldUnitsMarkers[id], newUnitsMarkers[id]))
                    .filter(o => o)
                if(this.$isDevelopment) console.log('SectionMap watch unitsMarkersOptions', diff)
                if(diff.length) {
                    this.debouncedUpdateMarkers();
                }
            },
            deep: true,
            // immediate: true,
        },
    },
    methods: {
        ...mapActions([
        ]),
        modalClose() {
            this.modalWindows = {}
        },
        unitClick(unit) {
            this.setRoute.unitInfo(this.$route, this.$router, unit.id)
        },
        updateVisibleUnitsList() {
            let markers = (!this.mapBounds) ? [] :
                Object.values(this.unitsGroupsCluster?._featureGroup?._layers || {})
                    .filter(m => m?.meta && this.mapBounds.contains(m.getLatLng()))
                    .map(m => m.meta)

            this.unitsIdsWithoutCluster = markers
        },
        setMarkers(unitIds) {
            let markers = this.getUnitsMarkers()
            // removed
            let removed = markers.filter(m => {
                return !unitIds.find(id => id == m?.meta?.id)
            })
            if (this.unitsGroupsCluster && removed?.length) {
                this.unitsGroupsCluster.removeLayers(removed)
            }
            // added
            let added = unitIds?.filter(id => {
                return !markers.find(m => m?.meta?.id == id)
            })
            this.addMarkers(added);
        },
        addMarkers(unitIds) {
            let markers = this.getUnitsMarkers()
            unitIds.forEach(id => {
                let options = this.getUnitsMarkersOptionsByIds[id]
                if (!options || !options.latlng) return false

                let marker = markers.find(m => m?.meta?.id == id)
                if (!marker) {
                    marker =
                        this.L.marker(options.latlng, { icon: this.unitIcon })
                        // new DriftMarker(options.latlng, {icon: this.unitIcon})
                    // L_movingMarker([options.latlng], 100, { icon: this.unitIcon, autostart: true})
                    // this.L.animatedMarker(options.latlng, { icon: this.unitIcon,
                    //     // distance: 500,  // meters
                    //     // interval: 1000, // milliseconds
                    // })
                    let group = this.groupsFiltered.find(g => !!g.units.find(uId => uId == id))
                    if (!options.styleName) options.styleName = {}
                    options.styleName.background = group.color
                    let icon = this.unitIconByType(options);
                    marker.setIcon(icon);

                    if(!this.routeMeta.isGuest) {
                        marker.on('click', this.markerOnClick)
                    }
                    marker.meta = {...options}
                    if (this.unitsGroupsCluster) {
                        this.unitsGroupsCluster.addLayer(marker)
                    }
                }
            })
        },
        updateMarkers() {
            let updated = 0
            let moved = 0
            let markers = this.getUnitsMarkers()
            this.unitsOnMap.forEach(id => {
                let options = this.unitsMarkersOptions[id]
                if (!options || !options.latlng) return false

                let marker = markers.find(m => m?.meta?.id == id)
                if (!marker) {
                    if(this.$isDevelopment) console.error('updateMarkers', 'no marker', id)
                    return false
                }

                let group = this.groupsFiltered.find(g => !!g.units.find(uId => uId == id))
                if (!options.styleName) options.styleName = {}
                options.styleName.background = group.color
                let diff = diffObjects(marker.meta, options) || {}
                delete diff.time
                if (!Object.keys(diff).length) return false

                if(['name','icon_has_halo','course','styleIcon','styleName','statusClass','img_src'].filter(fld => Object.keys(diff).includes(fld)))
                {
                    if(this.$isDevelopment) console.log('updateMarkers', 'diffMarkerOptions', diff)
                    let icon = this.unitIconByType(options);
                    marker.setIcon(icon);
                    updated++
                }
                if (diff.latlng && marker?.meta?.time < options.time) { //  && (marker.options.latLng.lat != options.latLng.lat || marker.options.latLng.lon != options.latLng.lon)
                    // debugger
                    marker.setLatLng(options.latlng)//overloads style settings
                    moved++
                    //marker.options.time = options.time
                }
                // marker.meta = {...marker.meta, ...diff}
                updateObjectByDiff(marker.meta, options)
            })
            if (markers.length) {
                if(this.$isDevelopment) console.log('updateMarkers', markers.length, 'moved=', moved, 'updated=', updated)
            }
        },

        getUnitsMarkers(){
            return this.unitsGroupsCluster?.getLayers() || []
        },

        markerOnClick(event) {
            //if(this.$isDevelopment) console.log('markerOnClick', event)//target.meta.id
            this.setRoute.unitInfo(this.$route, this.$router, event.target.meta.id)
        },
        onReady() {
            if(this.$isDevelopment) console.log('ready')
            this.unitsGroupsCluster = this.$refs.unitsGroupsCluster.leafletObject
            this.unitsGroupsLayer = this.$refs.unitsGroupsLayer.leafletObject
        },
        _defaultClusterIconCreate(cluster) {
            let childCount = cluster.getChildCount();

            let c = ' marker-cluster-';
            if (childCount < 10) {
                c += 'small';
            } else
            if (childCount < 100) {
                c += 'medium';
            } else {
                c += 'large';
            }

            return this.L.divIcon({
                className: 'marker-cluster ' + c,
                html: '<div class="units-groups-cluster"><span>' + childCount + '</span></div>',
                iconSize: [40,40],
            });
        },
        onClusterClick(a) {
            if(this.$isDevelopment) console.log('cluster', a.layer.getAllChildMarkers().map(m => m.meta));
        },
    },
    created() {
        this.debouncedUpdateMarkers = debounce(this.updateMarkers, 1000)
        this.debouncedSetMarkers = debounce(this.setMarkers, 1000)
        this.debouncedUpdateVisibleUnitsList = debounce(this.updateVisibleUnitsList, 1000)
    },
    mounted() {
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
    },
    beforeUnmount() {
    }
}
</script>

<style scoped lang="scss">
.units-groups-on-map {
    position: absolute;
    z-index: 400;
    top: 10px;
    right: 50px;
    background: var(--Elements-BG);
    padding: 10px;
    border-radius: 8px;
    max-height: calc(100% - 30px);
    display: grid;
    grid-template-rows: auto 1fr;
    overflow: hidden;

    &__list {
        display: grid;
        gap: 10px;
        overflow: auto;
        height: 100%;
        @include scroll(var(--section-list-scroll-bg), var(--section-list-scroll-item), 6px);
    }

    &__item {
        display: grid;
        grid-template-columns: 20px 1fr 20px;
        gap: 5px;
        cursor: pointer;
    }

    &__color {
        width: 15px;
        height: 15px;
        border-radius: 100%;
    }
}
</style>